"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = void 0;
var _loggingStateService = require("@smartsheet/logging-state-service");
var _react = _interopRequireDefault(require("react"));
var _logging = require("../../util/logging");
var _SelectBase = require("./SelectBase");
var _SingleValue = require("./components/SingleValue");
var _ValueContainer = require("./components/ValueContainer");
var _selectConstants = require("./selectConstants");
/**
 * Wraps the SelectBase component with correct props for a "Single" select (versus the blend of
 * Single- and Multi- select props that SelectBase takes).
 */
const Select = _ref => {
  let {
    validationState = "default",
    maxOptionsUntilVirtualization = _selectConstants.MAX_OPTIONS_UNTIL_VIRTUALIZATION,
    optionHeight = _selectConstants.DEFAULT_ITEM_HEIGHT,
    closeMenuOnScroll = false,
    createOptionPosition = "last",
    isClearable = true,
    isSearchable = true,
    menuPortalTarget = document.body,
    menuPlacement = "auto",
    onChange,
    components,
    ...restProps
  } = _ref;
  const withLogging = (0, _logging.useLoggingDecorator)({
    clientId: restProps.clientId,
    controlType: "sel"
  });
  const onChangeWithLogging = (0, _logging.useLoggingEnabledByDefault)(withLogging, {
    actionId: _loggingStateService.LogActionId.CLICK
  }, onChange);
  const newProps = {
    // Putting these above restProps as they were only created to provide defaults--so it
    // doesn't matter if these are before or after the restProps spread.
    validationState,
    maxOptionsUntilVirtualization,
    closeMenuOnScroll,
    createOptionPosition,
    isClearable,
    isSearchable,
    optionHeight,
    menuPortalTarget,
    menuPlacement,
    components: {
      SingleValue: _SingleValue.SingleValue,
      ValueContainer: _ValueContainer.ValueContainer,
      ...components
    },
    ...restProps,
    // These *must* be after the restProps spread, since we don't want to let the consumer override them
    onChange: (value, action) => {
      void onChangeWithLogging(Array.isArray(value) ? value[0] : value, action);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_SelectBase.SelectBase, newProps);
};
exports.Select = Select;
//# sourceMappingURL=Select.js.map